import {
  Box,
  Button,
  Alert,
  Card,
  Container,
  Grid,
  InputAdornment,
  Typography,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  InputLabel,
  ButtonGroup
} from '@mui/material';
import { Helmet } from 'react-helmet';
import { Search as SearchIcon, Download as ExportIcon } from 'react-feather';
import TextField from '@mui/material/TextField';
import CustomButton from 'src/components/common/customButton';
import FormControl from '@mui/material/FormControl';
import BasicMenu from 'src/components/common/BasicMenu';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Download } from 'react-feather';
import { _axios } from 'src/plugins/axios';
import commonService from 'src/service/common';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';

const menuList = [
  {
    id: 'employeeId',
    title: 'EmployeeId'
  }
];

function EligiblePackages() {
  const [searchEmpId, setSearchEmpId] = useState('');
  const [isFound, setIsFound] = useState('false');
  const [packages, setPackages] = useState([]);
  const [empIdsFromFile, setEmpIdsFromFile] = useState([]);
  const [page, setPage] = useState(1);
  const [exportType, setExportType] = useState('xlsx');

  function downloadEligiblePackages() {
    let empId = [];
    if (searchEmpId) empId.push(searchEmpId);
    else empId = empIdsFromFile;
    _axios
      .post(
        'ahc/eligibledata',
        { empId: empId, fileType: exportType },
        {
          ignoreLoading: false,
          headers: {
            authtoken: commonService.getAuthToken(),
            'Content-Type': 'application/json'
          }
        }
      )
      .then((response) => {
        if (response.data.isSuccess) {
          downloadFile(response.data.preSignedUrl);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function onFileSelect(file) {
    const reader = new FileReader();
    reader.onload = (evt) => {
      // evt = on_file_select event
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      let data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
      /* Update state */
      data = data.split('\n');
      setEmpIdsFromFile(data);
    };
    reader.readAsBinaryString(file);
  }

  function downloadFile(url) {
    var link = document.createElement('a');
    link.setAttribute('download', '');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  function downloadTemp(){
    _axios
    .post('ahc/providerlist', {fileTemp: true})
    .then((response) => {
      if (
        response.data &&
        response.data.isSuccess &&
        response.data.preSignedUrl
      ) {
        downloadFile(response.data.preSignedUrl);
      }
      else{
        alert('Something Went Wrong')
      }
    })
    .catch((err)=>{
      alert('Something Went Wrong')
    })
  }

  function handleSearch(p) {
    let empId = [];
    if (searchEmpId) empId.push(searchEmpId);
    else empId.push(empIdsFromFile[p]);
    _axios
      .post(
        'ahc/eligibledata',
        { empId: empId },
        {
          ignoreLoading: false,
          headers: {
            authtoken: commonService.getAuthToken(),
            'Content-Type': 'application/json'
          }
        }
      )
      .then((response) => {
        if (response.data.isSuccess && response.data.result.length > 0) {
          setPackages(response.data.result);
          setIsFound(true);
        } else {
          setIsFound(false);
        }
      })
      .catch((error) => {
        setIsFound(false);
      });
  }
  let year = new Date().getFullYear() % 2000,
    month = new Date().getMonth();
  if (month > 3) year = year + 1;
  let fYears = [
    `${year - 1}-${year}`,
    `${year - 2}-${year - 1}`,
    `${year - 3}-${year - 2}`,
    `${year - 4}-${year - 3}`
  ];

  return (
    <>
      <Helmet>
        <title>AHC | Repository</title>
      </Helmet>
      <Grid
        container
        sx={{
          width: '100%',
          borderRadius: 4,
          p: 3,
          pt: 2
        }}
      >
        <Grid item xs={12}>
          <Card
            sx={{
              width: '100%',
              borderRadius: 4,
              mb: 2,
              p: 3,
              boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
            }}
          >
            <Grid container>
              <Grid item sx={12} container>
                <Grid item sm={8}>
                  <FormControl
                    sx={{
                      display: 'flex',
                      flexDirection: 'row'
                    }}
                    size="small"
                    variant="filled"
                    fullWidth
                  >
                    <OutlinedInput
                      id="outlined-search"
                      sx={{
                        boxShadow: 0,
                        bgcolor: '#f2f2f2'
                      }}
                      labelWidth={0}
                      value={searchEmpId}
                      onChange={(e) => setSearchEmpId(e.target.value)}
                      placeholder={`Enter EmployeeId`}
                    />
                    <InputLabel sx={{ ml: 24, mt: 0.3 }}>OR</InputLabel>
                    <OutlinedInput
                      sx={{ ml: 6, width: '32%' }}
                      type="file"
                      onChange={(e) => {
                        onFileSelect(e.target.files[0]);
                      }}
                    ></OutlinedInput>
                  </FormControl>
                  <Button sx={{
                      margin: '5px',
                      // boxShadow: '0 0 4px rgba(0,0,0,0.20)'
                    }} onClick={()=>{
                    downloadTemp()
                  }}>Click Here to Download file Template</Button>
                </Grid>
                <Grid item>
                  <Button
                    sx={{ ml: 2, px: 3, boxShadow: '0 0 4px rgba(0,0,0,0.20)' }}
                    color="primary"
                    startIcon={<SearchIcon size="18" />}
                    onClick={() => {
                      handleSearch(page);
                    }}
                  >
                    {' '}
                    Get Eligibility
                  </Button>
                  <Button
                    sx={{ ml: 2, px: 3, boxShadow: '0 0 4px rgba(0,0,0,0.20)' }}
                    onClick={() => { downloadEligiblePackages() }}
                    startIcon={<ExportIcon size="18" />}
                  >
                    Export
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          width: '100%',
          borderRadius: 4,
          p: 3,
          pt: 2
        }}
      >
        <Grid item xs={12}>
          <Card
            sx={{
              width: '100%',
              borderRadius: 4,
              mb: 2,
              p: 3,
              boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
            }}
          >
            {isFound ? (
              <TableContainer>
                <Table
                  stickyHeader
                  aria-label="Eligible Packages"
                  id="eligible-packages"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Beneficiary Name</TableCell>
                      <TableCell>Beneficiary Relation</TableCell>
                      <TableCell>EmployeeId</TableCell>
                      <TableCell>Available Sponsored Packages</TableCell>
                      <TableCell>Available Paid Packages</TableCell>
                      <TableCell>Availed In FY {fYears[0]}</TableCell>
                      <TableCell>Availed In FY {fYears[1]}</TableCell>
                      <TableCell>Availed In FY {fYears[2]}</TableCell>
                      <TableCell>Availed In FY {fYears[3]}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {packages.map((item) => (
                      <TableRow>
                        <TableCell>{item.benefName}</TableCell>
                        <TableCell>{item.benefRelation}</TableCell>
                        <TableCell>{item.empId}</TableCell>
                        <TableCell>
                          <Table>
                            <TableBody>
                              {item.sponsoredPackages.length>0 ? item.sponsoredPackages.map((packagess) => (
                                <TableRow>
                                  <TableCell>
                                    {packagess.PackageName}{' '}
                                    <b>
                                      {' '}
                                      {'  -- '} {packagess.isPaid}{' '}
                                    </b>
                                  </TableCell>
                                </TableRow>
                              )): 'N/A'}
                            </TableBody>
                          </Table>
                        </TableCell>
                        <TableCell>
                          <Table>
                            <TableBody>
                              {item.paidPackages.length>0 ? item.paidPackages.map((packagess) => (
                                <TableRow>
                                  <TableCell>
                                    {packagess.PackageName}{' '}
                                    <b>
                                      {' '}
                                      {'  -- '} {packagess.isPaid}{' '}
                                    </b>
                                  </TableCell>
                                </TableRow>
                              )): 'N/A'}
                            </TableBody>
                          </Table>
                        </TableCell>
                        {item.availedPackages.map((item) => {
                          <TableCell></TableCell>;
                        })}
                        <TableCell>
                          {item.availedPackages.length > 0 &&
                            item.availedPackages[0].packageName
                            ? item.availedPackages[0].packageName
                            : 'N/A'}
                        </TableCell>
                        <TableCell>
                          {item.availedPackages.length > 0 &&
                            item.availedPackages[1].packageName
                            ? item.availedPackages[1].packageName
                            : 'N/A'}
                        </TableCell>
                        <TableCell>
                          {item.availedPackages.length > 0 &&
                            item.availedPackages[2].packageName
                            ? item.availedPackages[2].packageName
                            : 'N/A'}
                        </TableCell>
                        <TableCell>
                          {item.availedPackages.length > 0 &&
                            item.availedPackages[3].packageName
                            ? item.availedPackages[3].packageName
                            : 'N/A'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography xs={3} sx={{ ml: '42%', color: 'red' }}>
                No Employee found
              </Typography>
            )}
            <ButtonGroup sx={{ ml: '85%' }}>
              {page <= 1 ? (
                <Button disabled>Prev</Button>
              ) : (
                <Button
                  onClick={() => {
                    setPage(page - 1);
                    handleSearch(page - 1);
                  }}
                >
                  Prev
                </Button>
              )}
              {page >= empIdsFromFile.length ? (
                <Button disabled>Next</Button>
              ) : (
                <Button
                  onClick={() => {
                    setPage(page + 1);
                    handleSearch(page + 1);
                  }}
                >
                  Next
                </Button>
              )}
            </ButtonGroup>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}

export default EligiblePackages;
